@if (!showOnlyCalendarPopup()) {
  <div class="date-picker-wrapper">
    <label class="date-range-label b2 text-gray-800">
      {{ label() }}
      <div
        #calendarInputWrapper
        class="input-wrapper"
        [style.height]="datePickerInputHeight() || null"
        (click)="toggleCalendar($event)">
        <input
          type="text"
          [value]="getDatePickerLabel()"
          [attr.size]="getDatePickerLabel().length || 10"
          readonly />
        <i class="material-symbols-outlined calendar-icon" aria-hidden="true">
          calendar_today
        </i>
      </div>
    </label>
    @if (compareEnabled) {
      <label class="compare b2 text-gray-800" for="compareSwitchOutside">
        Compare
        <m-switch
          id="compareSwitchOutside"
          class="compare-switch mt-1"
          [(ngModel)]="compareToggledOn"
          [disabled]="disabled()"
          (onChange)="onOutsideCompareToggle($event.checked)">
        </m-switch>
      </label>
    }
  </div>
}

<m-modal
  [(visible)]="showCalendar"
  appendTo="body"
  styleClass="fiscal-calendar-dialog"
  [showHeader]="false"
  [showFooter]="false"
  [modal]="true"
  [focusTrap]="true"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  transitionOptions="0ms">
  <div
    #fiscalCalendarPopup
    class="fiscal-calendar-popup-content"
    [class.anchored]="!showOnlyCalendarPopup()">
    @if (showCalendar) {
      <portal-fiscal-calendar-popup
        [months]="months()"
        [startDate]="startDate()"
        [endDate]="endDate()"
        [previousStartDate]="previousStartDate()"
        [previousEndDate]="previousEndDate()"
        [minDate]="minDate()"
        [maxDate]="maxDate()"
        [relativeDate]="relativeDate()"
        [initialCompareOn]="forceCompareOn"
        (dateChanged)="onPopupDateChanged($event)"
        (cancelled)="onPopupCancelled()"
        (compareToggled)="compareToggledOn = $event">
      </portal-fiscal-calendar-popup>
    }
  </div>
</m-modal>
